module.exports = __webpack_public_path__ + "static/media/mujib-100-logo.62809a01.png";